import { render, staticRenderFns } from "./ProductSentiments.vue?vue&type=template&id=2a37b261&scoped=true"
import script from "./ProductSentiments.vue?vue&type=script&lang=js"
export * from "./ProductSentiments.vue?vue&type=script&lang=js"
import style0 from "./ProductSentiments.vue?vue&type=style&index=0&id=2a37b261&prod&scoped=true&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./ProductSentiments.vue?vue&type=style&index=2&id=2a37b261&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a37b261",
  null
  
)

export default component.exports